module.exports = __webpack_public_path__ + "media/images/doc-6d50cee4.png";